import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/nathan/Documents/GitHub/wmn-cms-docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "major-roadworks-and-events"
    }}>{`Major Roadworks and Events`}</h1>
    <p>{`These pages display any current or future roadworks or events which will cause travel disruption. All of these page are added through the CMS.`}</p>
    <h2 {...{
      "id": "how-it-looks"
    }}>{`How it looks`}</h2>
    <p><img alt="major-works-main-hub" src={require("../../../public/pages/major-works/main-hub/major-works-main-hub.png")} /></p>
    <h2 {...{
      "id": "functionality"
    }}>{`Functionality`}</h2>
    <ol>
      <li parentName="ol">{`Live Results - All events that are currently within todays date / time`}</li>
      <li parentName="ol">{`Planned Results - All events thats are after todays date / time`}</li>
      <li parentName="ol">{`Filter results by West Midlands area. The area will only appear if there's an event tagged in the area`}</li>
      <li parentName="ol">{`Related Content - Add custom links into this sidebar tile `}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      